import { createAction } from 'typesafe-actions';
import { EmptyPayload, MainResourceHandler } from './types';
import { initialState } from './util';

export function createClearAction<
  TItemKey,
  TItemSummary extends TItemKey,
  TItemBody extends TItemKey,
>(displayName: string) {
  const clear = createAction(`@${displayName}/clear`)<EmptyPayload>();

  const clearHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof clear
  > = () => initialState;

  return {
    clear,
    clearHandler,
  };
}
